<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">投票设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>批次设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-batch @refresh="refreshList"></create-batch>
      </div>
      <batch-list @refresh="refreshList"></batch-list>
      <batch-detail @refresh="refreshList"></batch-detail>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState } from 'vuex';
import CreateBatch from './components/create';
import BatchList from './components/list';
import BatchDetail from './components/detail';
import { PAGINATION } from 'common/config';

export default {
  name: 'VoteBatch',
  components: {
    CreateBatch,
    BatchList,
    BatchDetail
  },
  data() {
    return {
      query: ''
    };
  },
  computed: {
    ...mapState('voteBatchSetting', ['pagination'])
  },
  methods: {
    ...mapActions('voteBatchSetting', ['list', 'listAllCoin']),
    refreshList(data) {
      this.list({
        batchNo: this.query,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.list({ ...PAGINATION });
    this.listAllCoin();
  }
};
</script>

<style></style>
